module.exports = __webpack_public_path__ + "static/211-logo-be4b5ffb4967f6d82babd08dc91a41bc.png";